import { TEmailAlert } from "~/types/model";

export default class OrderNotary {

  id!: number;
  orderId!: number;
  notaryId!: number;
  status!: number;
  meetingAddress!: string;
  isInactive!: boolean;
  collectedPaymentInfo!: any | null;
  amount!: number | null;
  qbDocId!: number | null;
  qbDocNo!: string | null;
  qbDocCreatedTs!: number | null;
  paymentId!: number | null;
  statementId!: number | null;
  accountingNotes!: string | null;
  notaryFullName!: string;
  notaryPhone!: string;
  notaryEmail!: string;
  userNotaryId!: number;
  notaryImage!: string | null;
  emailAlert!: TEmailAlert | null;
  notaryTimezone!: string;
  meetingTs!: number;
  completedTs!: number | null;
  updatedTs!: number;
  createdTs!: number;

  static STATUS_ASSIGNED = 0;
  static STATUS_DOCS_RECEIVED = 1;
  static STATUS_APPOINTMENT_SET = 2;
  static STATUS_APPOINTMENT_DECLINED = 3;
  static STATUS_APPOINTMENT_ACCEPTED = 4;
  static STATUS_DOCS_PRINTED = 5;
  static STATUS_DOCS_UPLOADED = 6;
  static STATUS_ORDER_COMPLETE = 7;
}